module.exports = __webpack_public_path__ + "img/Git.3b6526b4.png";